
const API_PREFIX_TEST = process.env.REACT_APP_API_PREFIX_TEST;
const API_PREFIX_TEST_B = process.env.REACT_APP_API_PREFIX_TEST_B;
const API_PREFIX_PRE = process.env.REACT_APP_API_PREFIX_PRE;
const API_PREFIX_PROD = process.env.REACT_APP_API_PREFIX_PROD;

const ENV = process.env.REACT_APP_ENVIRONMENT;
console.log("ENV", ENV);

export function getParameterByName(name, url) {
  name = name.replace(/[\\[]/, "\\[").replace(/[\\]]/, "\\]");
  var regex = new RegExp("[\\?&#]" + name + "=([^&#]*)"),
    results = regex.exec(url || window.location.search || window.location.hash);
  return results == null ? "" : decodeURIComponent(results[1]);
}

export function getEnviroment(){
  if(ENV === 'prod') {
    return "release";
  }
  let env = getParameterByName('env');
  if (env === 'test') {
    return 'test';
  } else if(env === 'testb'){
    return 'testb';
  }else if(env === 'pre') {
    return 'pre';
  } else if(env === 'prod_old') {
    return 'prod_old';
  }
  return 'release';
}

export function getHostName(){
  if (ENV === 'prod') {
    return API_PREFIX_PROD;
  }
  let env = getEnviroment();
  if(env === 'test') {
    return API_PREFIX_TEST;
  } else if(env === 'testb') {
    return API_PREFIX_TEST_B;
  } else if (env === 'pre') {
    return API_PREFIX_PRE;
  }
  return API_PREFIX_PROD;
}

export function getChainsApiHost(){
  if (ENV === 'prod') {
    return API_PREFIX_PROD;
  }
  let env = getEnviroment();
  if (env === 'test') {
    return API_PREFIX_TEST;
  } else if (env === 'testb') {
    return API_PREFIX_TEST;
  } else if (env === 'pre') {
    return API_PREFIX_TEST;
  }
  return API_PREFIX_PROD;
}
